var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_10348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.707 0.293C15.8792 0.465193 15.9826 0.694293 15.9979 0.937319C16.0132 1.18034 15.9393 1.4206 15.79 1.613L15.707 1.707L1.707 15.707C1.52704 15.8863 1.28557 15.9905 1.03162 15.9982C0.777667 16.006 0.530287 15.9168 0.339721 15.7488C0.149156 15.5807 0.0296947 15.3464 0.00560108 15.0935C-0.0184925 14.8406 0.0545882 14.588 0.21 14.387L0.293 14.293L2.741 11.843C1.061 10.43 0 8.715 0 8C0 6.686 3.582 2 8 2C9.29 2 10.508 2.4 11.587 2.997L14.293 0.293C14.4805 0.105529 14.7348 0.000213623 15 0.000213623C15.2652 0.000213623 15.5195 0.105529 15.707 0.293ZM14.285 5.132C15.359 6.285 16 7.444 16 8C16 9.314 12.418 14 8 14C7.235 14 6.495 13.86 5.795 13.62L7.454 11.963C8.06609 12.0476 8.68946 11.9892 9.27521 11.7925C9.86096 11.5958 10.3932 11.266 10.8301 10.8291C11.267 10.3922 11.5968 9.85996 11.7935 9.27421C11.9902 8.68845 12.0486 8.06509 11.964 7.453L14.284 5.132H14.285ZM8 4C7.29473 3.99983 6.60195 4.18613 5.99189 4.54002C5.38183 4.89392 4.87619 5.40282 4.52622 6.01513C4.17625 6.62745 3.9944 7.32141 3.99911 8.02667C4.00381 8.73193 4.1949 9.4234 4.553 10.031L6.067 8.517C5.97695 8.17791 5.97755 7.82112 6.06873 7.48233C6.15991 7.14354 6.33848 6.83465 6.58657 6.58657C6.83465 6.33848 7.14354 6.15991 7.48233 6.06873C7.82112 5.97755 8.17791 5.97695 8.517 6.067L10.031 4.553C9.41588 4.18978 8.71435 3.99877 8 4Z",
    fill: "#30313D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_10348"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHide);
export default __webpack_public_path__ + "static/media/eye-hide.43cbe36103388ebd8d2a61d708f15acc.svg";
export { ForwardRef as ReactComponent };